import React from 'react';
import { Anchor, MapPin, Phone, Mail } from 'lucide-react';
import { contactInfo } from '../data/mock';

const Footer = () => {
  return (
    <footer className="bg-gray-950 border-t border-gray-800">
      {/* Contact Section */}
      <div className="py-12 border-b border-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Brand */}
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-10 h-10 rounded-lg bg-orange-500 flex items-center justify-center">
                  <Anchor className="w-6 h-6 text-white" />
                </div>
                <span className="text-xl font-semibold text-orange-500">CC Yachting</span>
              </div>
              <p className="text-white/60 text-sm leading-relaxed">
                Luxury yacht charter experiences in Asia's most beautiful coastal regions.
              </p>
            </div>

            {/* Address */}
            <div>
              <h4 className="text-white font-semibold mb-4 flex items-center gap-2">
                <MapPin className="w-5 h-5 text-orange-500" />
                Location
              </h4>
              <address className="text-white/60 text-sm not-italic leading-relaxed">
                {contactInfo.location}<br />
                {contactInfo.address}
              </address>
            </div>

            {/* Contact */}
            <div>
              <h4 className="text-white font-semibold mb-4">Contact</h4>
              <div className="space-y-3">
                <a 
                  href={`tel:${contactInfo.phone}`}
                  className="flex items-center gap-3 text-white/60 text-sm hover:text-orange-500 transition-colors"
                >
                  <Phone className="w-4 h-4 text-orange-500" />
                  {contactInfo.phone}
                </a>
                <a 
                  href={`mailto:${contactInfo.email}`}
                  className="flex items-center gap-3 text-white/60 text-sm hover:text-orange-500 transition-colors"
                >
                  <Mail className="w-4 h-4 text-orange-500" />
                  {contactInfo.email}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="py-6">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <span className="text-white/50 text-sm">
              © 2025 CC Yachting. All rights reserved.
            </span>
            <a
              href="https://app.emergent.sh/?utm_source=emergent-badge"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 px-4 py-2 bg-gray-800 rounded-lg text-white/70 text-sm hover:bg-gray-700 transition-colors"
            >
              <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor">
                <circle cx="12" cy="12" r="10" />
              </svg>
              Made with Emergent
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
